import { head } from 'lodash-es'

export const SKU_PATTERNS = [
  /[Bb][Uu][Aa]\d{4}/g,
  /[Kk][Dd]\d{10}/g,
  /[Kk][Dd]\d{9}/g,
  /[Kk][Dd]\d{8}/g,
  /[Kk][Dd]\d{5}/g,
  /[Aa][Mm]\d{9}/g,
  /[Kk][Dd]\d{4}[Kk]\d{7}/g,
  /\d{4}[Kk]\d{7}/g,
  /[Xx][Uu]\d{9}/g,
  /[Xx][Uu]\d{8}/g,
  /[Kk][Dd][Mm][Ss]\d{9}/g,
  /[Kk][Dd][Mm][Ss]\d{8}/g,
  /[Kk][Dd][Ss][Pp]\d{9}/g,
  /[Xx][Uu][Mm][Ss]\d{8}/g,
  /\d{10,18}/g,
  /D?\d{9}/g,
  /\d{9}/g,
  /\d{8}/g,
  /\d{5}/g,
]

export const SKU_PATTERNS_WITH_SELECT = [/Derby_.+/g, /BUA?\d{4}/g, ...SKU_PATTERNS]

export const SKU_ONLY_PATTERNS = [
  /[Bb][Uu][Aa]\d{4}/g,
  /^[Kk][Dd]\d{10}$/,
  /^[Kk][Dd]\d{9}$/,
  /^[Kk][Dd]\d{8}$/,
  /^[Kk][Dd]\d{5}$/,
  /^[Aa][Mm]\d{9}$/,
  /^[Kk][Dd]\d{4}[Kk]\d{7}$/,
  /^\d{4}[Kk]\d{7}$/,
  /^[Xx][Uu]\d{9}$/,
  /^[Xx][Uu]\d{8}$/,
  /^[Kk][Dd][Mm][Ss]\d{9}$/,
  /^[Kk][Dd][Mm][Ss]\d{8}$/,
  /^[Kk][Dd][Ss][Pp]\d{9}$/,
  /^[Xx][Uu][Mm][Ss]\d{8}$/,
  /^\d{10,18}$/,
  /^D?\d{9}$/,
  /^\d{9}$/,
  /^\d{8}$/,
  /^\d{5}$/,
]

export const matchSku = (text, regex = SKU_PATTERNS) => {
  const matchedRegex = regex.find(re => {
    const hit = text.match(re)
    return hit && hit.length > 0
  })
  const hit = matchedRegex ? head(text.match(matchedRegex)) : undefined
  return hit
}

export const matchSkuWithSelect = text => {
  const match = matchSku(text, SKU_PATTERNS_WITH_SELECT)
  return match && match.length === 9 && head(match) !== 'D' ? `${match},D${match}` : match
}

export default SKU_PATTERNS
